import React, { Component } from 'react';
import { ErrorBox } from '../components/ErrorBox.tsx';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    applicant: number;
    gender: "" | "Male" | "Female";
    firstName: string;
    updateLead(props: any): void;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    gender:  "" | "Male" | "Female";
}

export class Gender extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {
            hasError: false, 
            gender: this.props.gender, 
        };
    }

    nextStep(gender: string) {
        if(this.props.applicant === 1) 
            this.props.updateLead({gender1: gender}); 
        else
            this.props.updateLead({gender2: gender}); 
        this.props.nextStep()
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>Tell us more <span className='doddltext'>about {this.props.applicant === 1 ? 'you' : this.props.firstName}</span></h1>
                <h2>{this.props.applicant === 1 ? 'I am a' : 'My partner is'}</h2>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <div className='boxty small' onClick={() => this.nextStep('Male')}>
                                <div>
                                    <div><h2 className='btn'>Male</h2></div>
                                </div>
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className='boxty small' onClick={() => this.nextStep('Female')}>
                                <div>
                                    <div><h2 className='btn'>Female</h2></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
